import React, {useEffect, useState} from 'react';
import {getDatabase, onValue, ref} from "firebase/database";
import app from "../../firebaseConfig/firebaseConfig";
import {CardContent} from "@mui/material";
import {useUser} from "../../managers/userManager/userManager";
import OrderCard from "../../user/userPage/components/OrderCard";
import {useSearchParams} from "react-router";

const db = getDatabase(app);

function VerifyOrder() {
    const user = useUser();
    const [params] = useSearchParams();
    const [orders, setOrders] = useState([]);
    const path = params.get('path');

    useEffect(() => {
        if (!db || !user.uid) {
            return;
        }

        const orderRef = ref(db, decodeURIComponent(path));
        onValue(orderRef, (snapshot) => {
            setOrders([snapshot.val()]);
        });
    }, [path, user]);

    return (orders &&
        <div className="myorders" style={{display: 'flex', justifyContent: 'center'}}>{Object.keys(orders).reverse().map(key => <CardContent key={key}>
                <OrderCard order={orders[key]}/>
            </CardContent>
        )}</div>
    );
}

export default VerifyOrder;
